/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { FormattedMessage } from 'react-intl'

import { EuiButtonEmpty, EuiDescriptionList, EuiPopover } from '@elastic/eui'
import type { EuiDescriptionListProps } from '@elastic/eui/lib/services'

import { useToggle } from '@modules/utils/hooks/useToggle'

import type { FunctionComponent } from 'react'

type Props = {
  listItems: EuiDescriptionListProps['listItems']
}

const InstanceInfoPopover: FunctionComponent<Props> = ({ listItems }) => {
  const [isPopoverOpen, togglePopover, setPopoverOpen] = useToggle()

  return (
    <EuiPopover
      anchorPosition='upCenter'
      ownFocus={true}
      button={
        <EuiButtonEmpty size='s' onClick={togglePopover}>
          <FormattedMessage defaultMessage='info' id='instance-configuration.info' />
        </EuiButtonEmpty>
      }
      isOpen={isPopoverOpen}
      closePopover={() => setPopoverOpen(false)}
    >
      <EuiDescriptionList listItems={listItems} />
    </EuiPopover>
  )
}

export default InstanceInfoPopover
